import * as TYPES from './type';
export default {
  //在线答疑
  [TYPES.CHAT_STU_LIST](state, { result }) {
    state.chatStuList = result.result
  },
  [TYPES.CHAT_DETAIL](state, { result }) {
    state.chatDetail = result.result
  },
  [TYPES.CHAT_REPLAY_STU](state, { result }) {
    state.chatReplayStu = result.result
  },
  [TYPES.CHAT_DEL](state, { result }) {
    state.chatDel = result.result
  },
  [TYPES.CHAT_EDIT](state, { result }) {
    state.chatEdit = result.result
  },
}
